import { render, staticRenderFns } from "./View.vue?vue&type=template&id=bc1ebc62&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=bc1ebc62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ebc62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc1ebc62')) {
      api.createRecord('bc1ebc62', component.options)
    } else {
      api.reload('bc1ebc62', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=bc1ebc62&scoped=true", function () {
      api.rerender('bc1ebc62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/swiper/View.vue"
export default component.exports